import type { IconProps } from "./types";

export const CheckIcon = ({ className = "h-3 w-3.5" }: IconProps) => (
  <svg
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M1 5L4.5 8.5L11 1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
